import { Link } from '@tanstack/react-router'
import { EmptyState } from '@/components/states'
import { Button } from '@/components/ui/button'
import { useT } from '@/i18n'

export function NotFound() {
  const t = useT()
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <EmptyState
        mood="curious"
        title={t('state.notFound')}
        description={t('state.notFoundHint')}
        action={
          <Button asChild variant="outline">
            <Link to="/">{t('state.goHome')}</Link>
          </Button>
        }
      />
    </div>
  )
}
